<template>
    <div class="q-pa-md">SYSTEM</div>
</template>